export const isAlphaNumeric = (value: string) => {
  const pattern = /^[a-zA-Z0-9]+$/;
  return pattern.test(value);
};
